import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';

import { SECTION_TITLE, SECTION_SINGLE_TITLE } from './constants';
import './styles.scss';

class HorizontalFilter extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { results } = this.props;

    return (
      <div id="HorizontalFilter">
        <div className="element-wrapper">
            <h5 className="element-header">
              {`${results} ${results === 1 ? SECTION_SINGLE_TITLE : SECTION_TITLE}`}
              <Button className="float-right add-button" size="small" href="/products/new">Nuovo prodotto</Button>
            </h5>
        </div>
      </div>
    );
  }
}

HorizontalFilter.defaultProps = {
  results: 0
};

HorizontalFilter.propTypes = {
  results: PropTypes.number.isRequired,
};

export default HorizontalFilter;
